"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledWrapperRight = exports.StyledWrapperLeft = exports.StyledWrapper = exports.StyledInputWrapper = exports.StyledInputContainer = exports.StyledInput = exports.StyledBoxRight = exports.StyledBoxMid = exports.StyledBoxLeft = exports.HelperText = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _utils = require("../lib/utils");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

var StyledInputWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n  ", "\n"])), _styledSystem.space, function (props) {
  return props.focused && "\n    label {\n      color: ".concat(props.color ? (0, _utils.getPalette)(props.color, 'c02')(props) : (0, _utils.getPalette)('primary', 'c02')(props), ";\n    }\n  ");
}, function (props) {
  return props.error && "\n    label,.eui-helper-text {\n        color: ".concat((0, _utils.getPalette)('error', 'c03')(props), ";\n    }\n    input {\n        border-color: ").concat((0, _utils.getPalette)('error', 'c03')(props), ";\n        &:hover, &:focus {\n            border-color: ").concat((0, _utils.getPalette)('error', 'c03')(props), ";\n        }\n    }\n  ");
});

exports.StyledInputWrapper = StyledInputWrapper;

var StyledInputContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n  display: flex;\n  border-radius: ", ";\n  transition: all 0.2 ease-in;\n\n  border: 1px solid\n    ", ";\n  align-items: center;\n  ", "\n  ", "\n  ", "\n  &:hover {\n    border-color: ", ";\n  }\n  ", "\n"])), function (props) {
  return (0, _utils.getBorderRadius)('tertiary')(props);
}, function (props) {
  return props.color ? (0, _utils.getPalette)(props.color, 'c01')(props) : (0, _utils.getPalette)('background', 'c03')(props);
}, function (props) {
  return props.disabled && "\n    background-color: ".concat((0, _utils.getPalette)('background', 'c02')(props), ";\n    cursor: not-allowed;\n  ");
}, function (props) {
  return props.focused && "\n    border-color: ".concat(props.color ? (0, _utils.getPalette)(props.color, 'c02')(props) : (0, _utils.getPalette)('primary', 'c02')(props), " !important;\n  ");
}, function (props) {
  return props.error && "\n      border-color: ".concat((0, _utils.getPalette)('error', 'c03')(props), " !important;\n      &:hover, &:focus {\n          border-color: ").concat((0, _utils.getPalette)('error', 'c03')(props), " !important;\n      }\n  ");
}, function (props) {
  return props.disabled ? 'transparent' : props.color ? (0, _utils.getPalette)(props.color, 'c02')(props) : (0, _utils.getPalette)('background', 'c03')(props);
}, function (props) {
  return (0, _utils.isRTL)(props) && "\n  text-align: right;\n  flex-direction: row-reverse;\n    .eui-input {\n      &-left {\n        padding: 0px;\n        padding-right: 14px;\n      }\n      &-right {\n        padding: 0px;\n        padding-left: 14px;\n      }\n    }\n  ";
});

exports.StyledInputContainer = StyledInputContainer;

var StyledInput = _styledComponents["default"].input(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  appearance: none;\n  display: block;\n  width: 100%;\n  ", ";\n  color: ", ";\n  background-color: transparent;\n  padding-top: 11px;\n  padding-bottom: 11px;\n  padding-left: 14px;\n  padding-right: 14px;\n  box-sizing: border-box;\n  margin: 0;\n  transition: all 0.2s ease-in;\n  border: none;\n  border-radius: ", ";\n\n  ", "\n\n  &:focus {\n    border-color: ", ";\n    outline: none;\n  }\n  ::placeholder {\n    ", "\n    color: ", ";\n  }\n  ::-ms-clear {\n    display: none;\n  }\n  ", "\n  ", "\n"])), function (props) {
  return (0, _utils.getTypography)('body')(props);
}, function (props) {
  return (0, _utils.getPalette)('dark', 'c300')(props);
}, function (props) {
  return (0, _utils.getBorderRadius)('tertiary')(props);
}, function (props) {
  return props.disabled && "\n    cursor: not-allowed;\n  ";
}, function (props) {
  return props.color ? (0, _utils.getPalette)(props.color, 'c02') : (0, _utils.getPalette)('primary', 'c02')(props);
}, function (props) {
  return (0, _utils.getTypography)('placeholder')(props);
}, function (props) {
  return (0, _utils.getPalette)('dark', 'c100')(props);
}, _styledSystem.width, function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right;";
});

exports.StyledInput = StyledInput;

var HelperText = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  margin-top: 4px;\n  color: ", ";\n"])), function (props) {
  return (0, _utils.getTypography)('helperText')(props);
}, function (props) {
  return (0, _utils.getPalette)('text', 'c01')(props);
});

exports.HelperText = HelperText;

var StyledWrapper = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  ", "\n"])), function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right;flex-direction: row-reverse;";
});

exports.StyledWrapper = StyledWrapper;

var StyledWrapperLeft = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  flex: 1;\n"])));

exports.StyledWrapperLeft = StyledWrapperLeft;

var StyledWrapperRight = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  ", ";\n  margin-top: 4px;\n  color: ", ";\n  ", ";\n"])), (0, _utils.getTypography)('helperText'), function (props) {
  return (0, _utils.getPalette)('text', 'c01')(props);
}, function (props) {
  return (0, _utils.getTypography)('helperText')(props);
});

exports.StyledWrapperRight = StyledWrapperRight;

var StyledBoxLeft = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", ";\n  color: ", ";\n"])), function (props) {
  return (0, _utils.isRTL)(props) ? "padding: 0px 14px 0px 0px;" : "padding: 0px 0px 0px 14px;";
}, function (props) {
  return (0, _utils.getTypography)('placeholder')(props);
}, function (props) {
  return (0, _utils.getPalette)('text', 'c01')(props);
});

exports.StyledBoxLeft = StyledBoxLeft;

var StyledBoxMid = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  flex: 1;\n"])));

exports.StyledBoxMid = StyledBoxMid;

var StyledBoxRight = _styledComponents["default"].div(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", ";\n  color: ", ";\n"])), function (props) {
  return (0, _utils.isRTL)(props) ? "padding: 0px 0px 0px 14px;" : "padding: 0px 14px 0px 0px;";
}, function (props) {
  return (0, _utils.getTypography)('placeholder')(props);
}, function (props) {
  return (0, _utils.getPalette)('text', 'c01')(props);
});

exports.StyledBoxRight = StyledBoxRight;